import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { statusOptions } from './data';

function StatusModal({showModal, handleCloseModal, status, notice}) {


  

  return (
      <Modal show={showModal} onHide={handleCloseModal} size="lg">
        <Modal.Header className='bg-dark'>
          <Modal.Title className='fs-5 text-white mb-0'>مرحلة الحالية للعريضة</Modal.Title>
          <Button variant="light" className="mb-0" size="sm" onClick={handleCloseModal} aria-label="Close"><i class="bi bi-x-lg"></i></Button>
        </Modal.Header>
        <Modal.Body>
        <div class="modal-body p-4">
				{/* <!-- Status Chart --> */}
                 {/* <!-- Step Buttons START --> */}
                 <div class="d-flex align-items-center justify-content-between">
                    {/* <!-- Step 1 --> */}
                    <div class="step mx-2">
                        <div class="d-grid text-center align-items-center">
                            <button type="button" class="btn btn-link step-trigger mb-0 disabled"  aria-controls="step-1">
                                {statusOptions[status]?.number > 1 ?
                                    <span class="bs-stepper-circle bg-success">1</span>
                                    : statusOptions[status]?.number === 1 ?
                                    <span class="bs-stepper-circle bg-success">
                                        <i class="bi bi-check-lg"></i>
                                    </span>
                                    :
                                    <span class="bs-stepper-circle">1</span>
                                    }
                            </button>
                            <p class="fw-light small text">{statusOptions['pending'].displayName}</p>
                        </div>
                    </div>
                    

                    {/* <!-- Step 2 --> */}
                    <div class="step mx-2">
                        <div class="d-grid text-center align-items-center">
                            <button type="button" class="btn btn-link step-trigger mb-0 disabled"  aria-controls="step-2">
                                {statusOptions[status]?.number > 2 ?
                                    <span class="bs-stepper-circle bg-success">2</span>
                                    : statusOptions[status]?.number === 2 ?
                                    ( statusOptions[status]?.value === 'secretary_accepted' || statusOptions[status]?.value === 'nominated' ?
                                    <span class="bs-stepper-circle bg-success">
                                        <i class="bi bi-check-lg"></i>
                                    </span> :
                                    <span class="bs-stepper-circle bg-danger">
                                        <i class="bi bi-x-lg"></i>
                                    </span>
                                    )
                                    :
                                    <span class="bs-stepper-circle">2</span>
                                    }
                            </button>
                            <p class="fw-light small">السكرتارية</p>
                        </div>
                    </div>
                    

                    {/* <!-- Step 3 --> */}
                    <div class="step mx-2">
                        <div class="d-grid text-center align-items-center">
                            <button type="button" class="btn btn-link step-trigger mb-0 disabled"  aria-controls="step-3">
                            {statusOptions[status]?.number > 3 ?
                                    <span class="bs-stepper-circle bg-success">3</span>
                                    : statusOptions[status]?.number === 3 ?
                                    ( statusOptions[status]?.value === 'manager_approved' ?
                                    <span class="bs-stepper-circle bg-success">
                                        <i class="bi bi-check-lg"></i>
                                    </span> :
                                    <span class="bs-stepper-circle bg-danger">
                                        <i class="bi bi-x-lg"></i>
                                    </span>
                                    )
                                    :
                                    <span class="bs-stepper-circle">3</span>
                                    }
                            </button>
                            <p class="fw-light small">الإدارة</p>
                        </div>
                    </div>
                    {/* <!-- Step 4 --> */}
                    <div class="step mx-2">
                        <div class="d-grid text-center align-items-center">
                            <button type="button" class="btn btn-link step-trigger mb-0 disabled"  aria-controls="step-3">
                            {statusOptions[status]?.number > 4 ?
                                    <span class="bs-stepper-circle bg-success">4</span>
                                    : statusOptions[status]?.number === 4 ?
                                    <span class="bs-stepper-circle bg-success">
                                        <i class="bi bi-check-lg"></i>
                                    </span>
                                    :
                                    <span class="bs-stepper-circle">4</span>
                                    }
                            </button>
                            <p class="fw-light small">{statusOptions['ready'].displayName}</p>
                        </div>
                    </div>
                    {/* <!-- Step 5 --> */}
                    <div class="step mx-2">
                        <div class="d-grid text-center align-items-center">
                            <button type="button" class="btn btn-link step-trigger mb-0 disabled"  aria-controls="step-3">
                            {statusOptions[status]?.number > 5 ?
                                    <span class="bs-stepper-circle bg-success">5</span>
                                    : statusOptions[status]?.number === 5 ?
                                    <span class="bs-stepper-circle bg-success">
                                        <i class="bi bi-check-lg"></i>
                                    </span>
                                    :
                                    <span class="bs-stepper-circle">5</span>
                                    }
                            </button>
                            <p class="fw-light small">{statusOptions['received'].displayName}</p>
                        </div>
                    </div>


                </div>
                {/* <!-- Step Buttons END --> */}


				{/* <!-- notice --> */}
                {notice && status === 'secretary_rejected' && <div className='mt-4'>
				<span class="badge bg-opacity-10 bg-warning text-warning">ملاحظة:</span>
				<p class="mb-0">{notice}</p>
                </div>}
			</div>
        </Modal.Body>
        <Modal.Footer>
          <Button className='my-0' variant="danger-soft" onClick={handleCloseModal}>
            إغلاق
          </Button>
        </Modal.Footer>
      </Modal>
  );
}
export default StatusModal

